import {
  ADD_CARS,
  PackagesSmokeTestPropVariantType,
  PARTIAL_STAYS,
} from "../../../../context/experiments";

export const getFeatureSmokeTestTitle = (
  variant: PackagesSmokeTestPropVariantType
) => {
  switch (variant) {
    case PARTIAL_STAYS:
      return "Thanks for showing interest in booking a package with partial hotel dates";
    case ADD_CARS: {
      return "Thanks for showing interest in adding a rental car to your package";
    }
    default:
      return undefined;
  }
};

export const TEST_SUBTITLE =
  "This feature isn't available yet, but we're considering it for the future to improve your experience.";

export const HOW_HELPFUL = "How useful would this feature be to you?";
export const NOT_USEFUL = "Not useful";
export const VERY_USEFUL = "Very useful";
